import { createFileRoute } from "@tanstack/react-router";

import Setlists from "@/features/gigs/Setlists";
import SideNavLayout from "@/layouts/SideNavLayout";
import { GigsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/gigs/setlists/")({
  component: () => (
    <SideNavLayout menu={<GigsMenu />}>
      <Setlists />
    </SideNavLayout>
  ),
});
